var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWalletConnectBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#walletConnectBlue_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#walletConnectBlue_svg__b)",
  d: "M48 0H0v48h48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.804 16.946c6.18-6.036 16.212-6.036 22.392 0l.744.732c.312.3.312.792 0 1.092l-2.544 2.484a.4.4 0 0 1-.564 0l-1.02-.996c-4.32-4.212-11.304-4.212-15.624 0l-1.092 1.068a.4.4 0 0 1-.564 0l-2.544-2.484a.754.754 0 0 1 0-1.092zm27.66 5.136 2.268 2.208c.312.3.312.792 0 1.092L32.52 35.354c-.312.3-.816.3-1.116 0l-7.248-7.08a.203.203 0 0 0-.276 0l-7.248 7.08c-.312.3-.816.3-1.116 0L5.268 25.382a.754.754 0 0 1 0-1.092l2.268-2.208c.312-.3.816-.3 1.116 0l7.248 7.08a.203.203 0 0 0 .276 0l7.248-7.08c.312-.3.816-.3 1.116 0l7.248 7.08a.203.203 0 0 0 .276 0l7.248-7.08c.336-.3.84-.3 1.152 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "walletConnectBlue_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(49.8298 0 0 42.0439 .007 24.093)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5D9DF6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006FFF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "walletConnectBlue_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "#fff",
  rx: 10
})))));
export default SvgWalletConnectBlue;